export const URL = "https://app.ticketmaster.com/discovery/v2/events.json";
export const API_KEY = "SD3dPZKqy7tpTs7VjSSru5mwqnGlbhOg";
export const pages = 50